export default {
  en: {
    'bundles-users-users-detail-components.permissions-tab-content.table.heading':
      '{selectedRole} Permissions',
    'bundles-users-users-detail-components.permissions-tab-content.fetch.fallback-error':
      'Failed to load user permissions.',
    'bundles-users-users-detail-components.permissions-tab-content.update.fallback-error':
      'Failed to update user permissions. Please try again.',
    'bundles-users-users-detail-components.permissions-tab-content.update.success':
      'User role updated successfully.',
  },
};
